import { message } from 'antd'

import { getMessage } from '../../../../../util/IntlMessages'

export const savingMessagesNotification = {
  saving: () =>
    message.loading({
      content: getMessage('savingChanges'),
      key: 'savingChanges'
    }),
  success: () => {
    message.destroy('savingChanges')
    message.success({
      content: getMessage('successSavingChanges'),
      key: 'savingField',
      duration: 1.5
    })
  }
}
